var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "861.000000pt",
    height: "453.000000pt",
    viewBox: "0 0 861.000000 453.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,453.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4974 3810 c-43 -10 -99 -45 -118 -75 -42 -64 -49 -126 -53 -487 l-5 -347 -1072 -3 c-971 -4 -1077 -6 -1131 -21 -110 -32 -184 -76 -276 -167 -72 -70 -93 -100 -127 -170 -22 -47 -45 -109 -52 -139 -17 -73 -15 -223 5 -296 45 -174 168 -325 337 -415 121 -65 86 -63 1253 -69 l1060 -6 5 -360 c5 -350 6 -361 28 -402 56 -105 110 -138 217 -131 55 3 69 9 107 40 76 62 599 571 858 834 300 305 402 420 442 501 29 60 30 65 26 180 -5 141 -15 166 -122 292 -190 226 -1166 1185 -1240 1220 -51 24 -101 31 -142 21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.4baff5c3ab9dc02058d2dd3055c19e47.svg";
export { ForwardRef as ReactComponent };